import type { ToolFilter } from "../providers/chat-provider";

const STORAGE_PREFIX = "chat-tool-filter";
const DEFAULT_KEY = `${STORAGE_PREFIX}-default`;
const HARD_CODED_DEFAULT: ToolFilter | null = null;

export function getToolFilter(chatSessionId: string): ToolFilter | null {
  const sessionKey = `${STORAGE_PREFIX}-${chatSessionId}`;
  const sessionValue = localStorage.getItem(sessionKey);
  if (sessionValue !== null) {
    try {
      return JSON.parse(sessionValue) as ToolFilter;
    } catch {
      // Ignore invalid JSON and fall back to defaults.
    }
  }

  const defaultValue = localStorage.getItem(DEFAULT_KEY);
  if (defaultValue !== null) {
    try {
      return JSON.parse(defaultValue) as ToolFilter;
    } catch {
      // Ignore invalid JSON and fall back to the hard-coded default.
    }
  }

  return HARD_CODED_DEFAULT;
}

export function setToolFilter(chatSessionId: string, filter: ToolFilter | null): void {
  const sessionKey = `${STORAGE_PREFIX}-${chatSessionId}`;
  if (filter === null) {
    localStorage.removeItem(sessionKey);
    return;
  }

  localStorage.setItem(sessionKey, JSON.stringify(filter));
}

export function getDefaultToolFilter(): ToolFilter | null {
  const value = localStorage.getItem(DEFAULT_KEY);
  if (value === null) {
    return null;
  }

  try {
    return JSON.parse(value) as ToolFilter;
  } catch {
    return null;
  }
}

export function setDefaultToolFilter(filter: ToolFilter | null): void {
  if (filter === null) {
    localStorage.removeItem(DEFAULT_KEY);
    return;
  }

  localStorage.setItem(DEFAULT_KEY, JSON.stringify(filter));
}
